import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { SupplierProfile } from '@/services/profile';

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  supplier: SupplierProfile | null;
  isHydrated: boolean;

  setSession: (s: { accessToken: string; refreshToken: string; supplier: SupplierProfile }) => void;
  setSupplier: (s: SupplierProfile) => void;
  setTokens: (accessToken: string, refreshToken?: string) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      supplier: null,
      isHydrated: false,
      setSession: (s) =>
        set({ accessToken: s.accessToken, refreshToken: s.refreshToken, supplier: s.supplier }),
      setSupplier: (s) => set({ supplier: s }),
      setTokens: (accessToken, refreshToken) =>
        set({ accessToken, refreshToken: refreshToken ?? get().refreshToken }),
      logout: () => set({ accessToken: null, refreshToken: null, supplier: null }),
    }),
    {
      name: 'resstro_supplier_auth',
      onRehydrateStorage: () => (state) => {
        if (state) state.isHydrated = true;
      },
    },
  ),
);
